<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong><i class="fa fa-align-justify"/> Modifier consigne produit</strong>
          </div>
          <b-form>
            <b-form-group label="Garantie">
              <multiselect v-model="selectedGaranties"
                selectLabel='Appuyer sur entrer pour sélectionner' 
                selectedLabel='Sélectionné' 
                deselectLabel='Appuyer sur entrer pour désélectionner'
                tag-placeholder="Choisissez une garantie"
                placeholder="Choisissez une garantie"
                label="text"
                track-by="value"
                :options="allGaranties"
                :multiple="true"
                :taggable="true">
              </multiselect>
            </b-form-group>
            <b-form-group label="Famille produit" label-for="basicSelect">
              <b-form-select
                id="basicSelect"
                :plain="true"
                :options="famillesProduits"
                v-model="selectedFamilleProduit">
              </b-form-select>
              <span class="field-error">{{ errors.familleProduit }}</span>
            </b-form-group>
            <b-form-group label='Date début' label-for='date_debut'>
              <b-form-input id='date_debut' type='date'
                          :class="{hasError: errors.date_debut !== ''}"
                          v-model="date_debut">
              </b-form-input>
              <span class='field-error'>{{ errors.date_debut }}</span>
            </b-form-group>
            <b-form-group label='Date fin prévue' label-for='date_fin'>
              <b-form-input id='date_fin' type='date'
                          :class="{hasError: errors.date_fin !== ''}"
                          v-model="date_fin">
              </b-form-input>
              <span class='field-error'>{{ errors.date_fin }}</span>
            </b-form-group>
            <b-form-group>
              <b-form-group label="Pièces jointes" label-for='nom_fichier'>
                <b-form-file placeholder="Veuillez choisir ou déposer le(s) fichier(s) ici"
                          class="file-input"
                          drop-placeholder="Déposer le fichier ici..."
                          browse-text="Parcourir"
                          :state="errors.consigneAttachments !== '' ? false : null"
                          @change="addFileToConsigne($event)"
                          multiple
                          :disabled="isDisabled()">
                </b-form-file>
                <b-row>
                  <b-col sm="9"></b-col>
                  <b-col sm="3" style="text-align:right">
                    Le nombre de pièces jointes est limité à : {{ maxPjConsigne }}
                  </b-col>
                </b-row>
                <span class="field-error">{{ errors.consigneAttachments }}</span>
                <div v-if="pieceJointes">
                  <li v-for="pj in pieceJointes" :key="pj.id" style="list-style:none">
                    <a :id="`pj_${pj.id}`" href="#" @click.prevent="download(pj.id, pj.nom_fichier)" style="font-size:12px;color:#831491"><i class="fa fa-tag"></i> {{ pj.nom_fichier }}
                    ({{ formatBytes(pj.taille) }})</a>
                    <i class="fa fa-trash" v-if="canDelete(pj)" @click="deletePj(pj.id)" title="Supprimer pièce jointe" style="cursor:pointer;color:#cd0303;margin-left:6px"></i>
                  </li>
                </div>
              </b-form-group>
            </b-form-group>
            <b-form-group label="Commentaire" label-for="commentaire">
              <b-form-textarea
                id="commentaire"
                type="text"
                :class="{hasError: errors.commentaire !== ''}"
                rows="3"
                max-rows="6"
                v-model="commentaire">
              </b-form-textarea>
              <span class="field-error">{{ errors.commentaire }}</span>
            </b-form-group>
            <div class="mt-5" slot="footer">
              <b-button type="button" @click="returnBack" size="md" variant="secondary">
                <i class="fa fa-arrow-left"/> Liste des consignes
              </b-button>
              <b-button type="button" @click="edit('stay')" size="md" class="pull-right" variant="primary">
                <i class="fa fa-save"/> Enregistrer
              </b-button>
              <b-button type="button" @click="edit('quit')" size="md" class="pull-right mr-2" variant="warning">
                <i class="fa fa-save"/> Enregistrer et Quitter
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "../../../../utils/auth"
  import {hasRule} from "@/utils/rulesHelper"
  import {downloadFile, guardedFile, isEmpty} from "@/utils/fileHelper"
  import {MAX_PJ_CONSIGNE} from '@/utils/constants'
  import Multiselect from 'vue-multiselect';

  export default {
    name: "Edit",
    data() {
      return {
        id: null,
        selectedFamilleProduit: null,
        commentaire: "",
        date_debut: '',
        date_fin: '',
        consigneAttachments: null,
        pieceJointePlaceholder: null,
        pieceJointes: null,
        famillesProduits: [],
        maxPjConsigne: MAX_PJ_CONSIGNE,
        allGaranties: [],
        selectedGaranties: [],
        errors: {
          commentaire: "",
          date_debut: "",
          date_fin: "",
          familleProduit: "",
          consigneAttachments: ''
        },
      }
    },
    components: {
      Multiselect,
    },
    mounted() {
      this.getFamillesProduits();
      this.id = this.$route.params.id;
      this.getConsigneProduit('produit');
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
      this.getFamillesProduits();
      this.getGarantiesConsignes();
    },
    methods: {
      getGarantiesConsignes() {
        this.$store.commit('IS_LOADING', true);
        this.$axios
          .get('/espaceGestion/consignes-garanties')
          .then(response => {
            this.$store.commit('IS_LOADING', false);
            const garanties = response.data.garanties;
            for (let i = 0; i < garanties.length; i++) {
              if (garanties[i].groupe !== 'DBCO') {
                this.allGaranties.push({
                  text: garanties[i].groupe,
                  value: garanties[i].groupe
                });
              }
            }
          })
          .catch(() => {
            this.handleError(this);
          });
      },
      getConsigneProduit(option) {
        this.$store.commit('IS_LOADING', true);
        this.$axios
          .get('/espaceGestion/consignes-produits/' + this.id)
          .then(response => {
            this.$store.commit('IS_LOADING', false);
            this.setForm(response.data.data, option);
          })
          .catch(() => {
            // this.handleError(this);
          });
      },
      setForm(consigneProduit, option) {
        this.selectedFamilleProduit = consigneProduit.famille_produit_id;
        this.commentaire = consigneProduit.commentaire;
        this.date_debut = consigneProduit.date_debut;
        this.date_fin = consigneProduit.date_fin;
        let pieceJointePlaceholder = []
        if (consigneProduit.consigne_attachments.length > 0) {
          _.forEach(consigneProduit.consigne_attachments, function(attachment) {
            if (attachment) {
              pieceJointePlaceholder.push(attachment.nom_fichier);
            }
          });
        }
        this.pieceJointePlaceholder = pieceJointePlaceholder.toString()
        this.pieceJointes = consigneProduit.consigne_attachments;
        if (option !== 'deletePj') {
          for (let data of consigneProduit.consigne_garanties) {
            if (data.garantie !== "") {
              this.selectedGaranties.push({
                text: data.garantie,
                value: data.garantie
              });
            }
          }
        }
      },
      getFamillesProduits() {
        this.$store.commit('IS_LOADING', true);
        this.$axios
          .get('/espaceGestion/consignes/famille-produit')
          .then(response => {
            this.$store.commit('IS_LOADING', false);
            const familles = response.data.data;
            for (let i = 0; i < familles.length; i++) {
              this.famillesProduits.push({
                text: familles[i].libelle,
                value: familles[i].id
              });
            }
          })
          .catch(() => {
            this.handleError(this);
          });
      },
      edit(type) {
        let self = this;
        if (this.validateData()) {
          let formData = new FormData();
          if (this.consigneAttachments) {
            for( var i = 0; i < this.consigneAttachments.length; i++ ){
              let file = this.consigneAttachments[i];
              formData.append('files[' + i + ']', file);
            }
          }
          this.$store.commit("IS_LOADING", true);
          formData.append('familleProduitId', this.selectedFamilleProduit);
          formData.append('commentaire', this.commentaire);
          formData.append('date_debut', this.date_debut);
          formData.append('date_fin', this.date_fin);
          formData.append('selectedGaranties', this.selectedGaranties.map((garantie) => garantie.value));

          this.$axios
            .post("/espaceGestion/consignes-produits/" + this.id, formData)
            .then(() => {
              this.$store.commit("IS_LOADING", false);
              this.$swal({
                position: "top",
                type: "success",
                title: "Modification avec succès",
                text: "La consigne a été bien modifiée ",
                showConfirmButton: false,
                timer: 5000
              });
              this.getConsigneProduit('deletePj');
              if (type === 'quit') {
                this.returnBack()
              } 
            })
            .catch(() => {
              this.handleError(this);
            });
        }
      },
      canDownloadGuardedFile(extension) {
        let valid = true;
        if(_.includes(guardedFile, extension)) {
          valid = hasRule(rules.CAN_DOWNLOAD_GUARDED_FILE);
        }
        return valid;
      },
      canDelete(pj) {
        return true
      },
      deletePj(pjId) {
        let self = this
        this.$swal.fire({
          title: 'Êtes-vous sûr?',
          text: 'Voulez-vous vraiment supprimer ce fichier ?',
          type: 'warning',
          reverseButtons: true,
          showCancelButton: true,
          cancelButtonColor:"#ff1744",
          confirmButtonText: 'Annuler',
          cancelButtonText: 'Supprimer',
        }).then((result) => {
          if (result.value !== true) {
            this.$store.commit('IS_LOADING', true)
            this.$axios
              .post("/espaceGestion/consignes/piece-jointe/delete/" + pjId)
              .then(response => {
                this.$store.commit('IS_LOADING', false)
                this.$swal({ position: 'top', type: 'success', title:'Suppression avec succès', text:'Le fichier a bien été supprimé',showConfirmButton: false, timer: 3000})
                let pjToRemove = _.filter(this.pieceJointes, (pj) => pj.id === pjId)
                let pjIndex = this.pieceJointes.indexOf(pjToRemove)
                this.pieceJointes.splice(pjIndex, 1)
                this.getConsigneProduit('deletePj')
              })
              .catch(function(error){
                self.$store.commit('IS_LOADING', false)
                self.$swal({ position: 'top', type: 'warning', title:'Attention !!', text:'Une erreur est survenue lors de la suppression du fichier. Si le problème persiste, merci de faire un ticket au support DOSI.',showConfirmButton: false, timer: 5000})
              })
          }
        })
      },
      download(id, filename) {
        let fileNameArr = filename.trim().split('.');
        let ext = fileNameArr.pop();
        let name = fileNameArr.join('.');
        let link = document.getElementById('pj_'+id);
        link.style.color = 'violet';
        // console.log('link',link)
        if(this.canDownloadGuardedFile(ext)) {
          this.$axios
            .get("/espaceGestion/consignes/piece-jointe/download/"+id, {responseType: 'blob'})
            .then(response => {
              downloadFile(response, name, ext);
            })
            .catch(() => {
              this.$swal({
                position: "top",
                type: "error",
                title: "Attention !!",
                text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
                showConfirmButton: false,
                timer: 4000
              });
            })
        } else {
          this.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Vous n'avez pas le droit pour télécharger cette pièce jointe",
            showConfirmButton: false,
            timer: 3500
          });
        }
      },
      addFileToConsigne(event) {
        this.consigneAttachments = event.target.files;
      },
      returnBack() {
        this.$router.push({path: "/espace-gestion/consignes-produit/list"});
      },
      validateData() {
        this.clearErrors()
        let dateFrom = new Date(this.date_debut)
        let dateTo = new Date(this.date_fin)
        let valid = true;

        if (this.selectedFamilleProduit === null) {
          this.errors.familleProduit = "La famille produit est obligatoire";
          valid = false;
        }
        if (this.pieceJointes && this.consigneAttachments) {
          let totalFileLength = this.pieceJointes.length + this.consigneAttachments.length
          if (totalFileLength > this.maxPjConsigne) {
            this.errors.consigneAttachments = "Le nombre de pièces jointes est limité à : " + this.maxPjConsigne
            valid = false
          }
        }
        if (isEmpty(this.commentaire)) {
          this.errors.commentaire = "La commentaire est obligatoire";
          valid = false;
        }

        if (!this.date_debut) {
            this.errors.date_debut = "La date de début est obligatoire"
            valid= false;
        }
        if (!this.date_fin) {
            this.errors.date_fin = "La date de fin est obligatoire"
            valid= false;
        }
        if (this.date_fin !== null && this.date_fin !== "") {
          if (dateTo.getTime() < dateFrom.getTime()) {
            this.errors.date_fin = "La date de fin doit être postérieure à la date de début"
            valid= false;
          }
        }

        return valid;
      },
      clearErrors() {
        this.errors.familleProduit = "";
        this.errors.commentaire = "";
        this.errors.consigneAttachments = "";
        this.errors.date_fin = "";
      },
      handleError(self) {
        self.$store.commit("IS_LOADING", false);
        self.$swal({
          position: 'top',
          type: 'error',
          title: 'Attention !!',
          text: 'Un problème est survenu, merci de contacter l\'administrateur',
          showConfirmButton: false,
          timer: 5000
        });
      },
      formatDate(textDate) {
        let date = textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
        return date;
      },
      formatBytes(bytes, precision = 2) {
        let units = ['o', 'Ko', 'Mo', 'Go', 'To']

        let varBytes = Math.max(bytes, 0);
        let pow = Math.floor((bytes ? Math.log(bytes) : 0) / Math.log(1024))
        pow = Math.min(pow, units.length - 1)

        varBytes /= Math.pow(1024, pow)

        return Math.round(varBytes, precision) + ' ' + units[pow]
      },
      isDisabled() {
        return (this.pieceJointes && this.pieceJointes.length >= this.maxPjConsigne) ? true : false
      },
    }
  }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
